import { h } from 'preact';

export default (props) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 55 55" role="img" {...props}>
			<path fill-rule="evenodd" clip-rule="evenodd" d="M2.7906 36.2785C0.733624 34.0226 -0.0624422 32.7618 0.00379352 32.6292C0.866279 31.8993 5.24581 27.852 5.97555 26.9893C6.57268 26.3257 17.3218 39.8615 17.8526 39.6625C18.1844 39.5961 45.3223 9.47281 47.9763 6.48693C53.9481 -0.081634 53.9481 -0.148098 54.147 0.0508379C54.3461 0.183516 54.7441 0.515313 54.9433 0.780668C55.1424 1.04602 55.1424 1.17871 49.1709 9.93724C43.1327 18.7619 31.1232 36.2124 25.0854 45.0371C18.9812 53.7953 18.8482 53.9947 18.7818 54.0608C18.6491 54.2599 4.18425 37.9373 2.79078 36.2784L2.7906 36.2785Z" />
		</svg>
	);
};